import React from "react";

import { Helmet } from "react-helmet-async";

const Placement = () => {
  return (
    <>
      <Helmet>
        <title>Placement | EduSkills</title>
      </Helmet>
    </>
  );
};

export default Placement;
